import { createFileRoute } from "@tanstack/react-router";
import { ComponentSizeTest } from "@/tests/components/ComponentSizeTest";

export const Route = createFileRoute("/demo/tests/component-size-test")({
  component: ComponentSizeTest,
});
